import { Check } from "lucide-react";
import { EVENT_TYPES } from "@/lib/eventTypes";

// Admin event form: several categories per event, the first ticked is the main one
export const EventTypePicker = ({ value = [], onChange }) => {
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  return (
    <div className="flex flex-wrap gap-2" data-testid="event-form-types">
      {EVENT_TYPES.map((t) => {
        const on = value.includes(t.key);
        return (
          <button key={t.key} type="button" onClick={() => toggle(t.key)} aria-pressed={on} data-testid={`event-form-type-${t.key}`}
            className={`inline-flex items-center gap-2 px-4 h-11 border text-sm font-bold uppercase tracking-[0.1em] transition-colors ${on ? "bg-white text-black border-white" : "border-white/30 text-white hover:border-white"}`}>
            {on && <Check className="w-4 h-4" />}{t.label}
          </button>
        );
      })}
    </div>
  );
};
